import axios from "axios/index";
import {getAPIUrl} from "@esnpm/node-toolbox";
import Promise from "bluebird";
export const API_SESSION_CART_SORT_ADDRESSES_REQUEST = "API_SESSION_CART_SORT_ADDRESSES_REQUEST";
export const API_SESSION_CART_SORT_ADDRESSES_SUCCESS = "API_SESSION_CART_SORT_ADDRESSES_SUCCESS";
export const API_SESSION_CART_SORT_ADDRESSES_FAILURE = "API_SESSION_CART_SORT_ADDRESSES_FAILURE";

export const api_session_cart_sort_addresses_request = (options) => {
	return {
		type: API_SESSION_CART_SORT_ADDRESSES_REQUEST,
		options: options,
		payload: {
			loading: true
		}
	};
};

export const api_session_cart_sort_addresses_success = (data) => {
	return {
		type: API_SESSION_CART_SORT_ADDRESSES_SUCCESS,
		payload: {
			loading: false,
			data: data,
			error: null
		}
	};
};

export const api_session_cart_sort_addresses_failure = (error) => {
	return {
		type: API_SESSION_CART_SORT_ADDRESSES_FAILURE,
		payload: {
			loading: false,
			error: error
		}
	};
};

/*
	Session.apiSessionCartSortAddresses
*/
export const apiSessionCartSortAddresses = (options) =>
	// eslint-disable-next-line no-unused-vars
	(dispatch, getState) => new Promise(
		// eslint-disable-next-line no-unused-vars
		(resolve, reject) => {
			dispatch(api_session_cart_sort_addresses_request(options));
			const url=getAPIUrl([
				{"url": "/api/session/cart/sort/addresses", "parameters": []},
			], options);
			axios({
				method: "get",
				url: url,
			}).then(
				(response) => {
					if (response.data.SUCCESSFUL) {
						dispatch(api_session_cart_sort_addresses_success(response.data.DATA));
						resolve();
					} else {
						dispatch(api_session_cart_sort_addresses_failure(response.data));
						resolve();
					}
				},
				(err) => {
					// eslint-disable-next-line no-console
					console.log(err);
					reject();
				}
			);
		}
	);
